module.exports = __webpack_public_path__ + "img/highRain.4bba74fb.svg";